var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-resource-options__cont" },
    _vm._l(_vm.settingsArray, function (settingItem) {
      return _c(
        "fieldset",
        {
          key: settingItem.typelex,
          staticClass: "alpheios-resource-options__cont-fieldset",
        },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.resourceSettingsTitle(settingItem.typeLex))),
          ]),
          _vm._v(" "),
          _vm._l(
            _vm.resourceSettingsLexicons(settingItem.typeLex),
            function (languageSetting) {
              return _c("setting", {
                key: languageSetting.name,
                attrs: {
                  classes: ["alpheios-resource-options__item"],
                  data: languageSetting,
                },
                on: { change: _vm.resourceSettingChanged },
              })
            }
          ),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }